// Paths
export const HOME_PATH = "/";
export const PRACTICE_PATH = "/practice";
export const UNITS_LIST_PATH = "/units";
export const STUDY_OPTIONS_PATH = "/study-options-page";

export const GAME_OPTIONS_PATH = "/game-options-page";

export const HIDE_AND_SEEK_PATH = "/hide-and-seek-page";
export const HIDE_AND_SEEK_TUTORIAL_PATH = "/hide-and-seek-tutorial";
export const RED_LIGHT_GREEN_LIGHT_PATH = "/red-light-green-light-page";
export const TUG_OF_WAR_PATH = "/tug-of-war-page";
export const SUGAR_HONEYCOMBS = "/sugar-honeycombs";
export const MARBLES = "/marbles";
export const CHATBOX_PATH = "/chatbox-page";
export const FLASHCARD_STUDY_PATH = "/flashcard-study-page";
export const ABOUT_PATH = "/about";
export const PROGRESS_PATH = "/progress-page";
export const LOGIN_PATH = "/login-page";
export const REGISTER_PATH = "/register-page";
export const LOGOUT_PATH = "/logout-page";
export const FORGOT_PASSWORD_PATH = "/forgot-password-page";
export const FEEDBACK_PATH = "/feedback-page";
export const MINGLE_PATH = "/mingle-page";
export const TEST_PATH = "/test-page";
export const JEGI_PATH = "/jegi-page";
export const FLYING_STONE_PATH = "/flying-stone-page";
export const GONG_GI_PATH = "/gong-gi-page";
export const JUMP_ROPE_PATH = "/jump-rope-page";

// API ENDPOINT
export const API_BASE_URL = "https://korean-game.modlangs.gatech.edu";
